import React from 'react';
import { Avatar } from '@mui/material';
import { avatarProps } from '../avatar';

export interface PersonAvatarProps {
  name?: string | null;
  /** The person's chosen avatar: an uploaded photo or a preset. */
  src?: string | null;
  /** Keeps the fallback colour stable for one person (their id). */
  seed?: string | null;
  size?: number;
  className?: string;
}

/**
 * A person's face: their uploaded photo or chosen preset avatar, and their
 * initials on a stable colour only when they have neither. The header used to
 * show the first letter of the name even for people with an avatar, while
 * their profile showed the avatar.
 */
export function PersonAvatar({ name, src, seed, size = 32, className }: PersonAvatarProps) {
  const props = avatarProps(name, src || null, seed);
  return (
    <Avatar
      {...props}
      alt=""
      className={className}
      sx={{ ...props.sx, width: size, height: size, fontSize: Math.round(size * 0.42) }}
    />
  );
}

export default PersonAvatar;
